/* eslint-disable no-plusplus */
/* eslint-disable react/no-this-in-sfc */
import React, { useState, useEffect } from 'react';
import Typewriter from 'typewriter-effect';
import Fade from 'react-reveal';
import { Helmet } from 'react-helmet';
import endpoints from '../constants/endpoints';
import Social from './Social';
import FallbackSpinner from './FallbackSpinner';
import { useLanguageContext } from '../TranslateContext';
import ParticlesComponent from './Particles';
import ScrambleText from './ScrambleText';

const styles = {
  nameStyle: {
    fontSize: '5em',
  },
  inlineChild: {
    display: 'inline-block',
    zIndex: 2,
  },
  mainContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflowX: 'hidden',
    position: 'relative',
  },
};

function Home() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(endpoints.home, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => err);
  }, []);

  const { t, i18n } = useLanguageContext();

  return data ? (
    <Fade>
      <Helmet>
        <meta property="og:title" content="Lucas Portfolio Website" />
        <meta property="og:description" content="🚀 Welcome to my portfolio! I’m a passionate full-stack developer who turns ideas into scalable, secure, and beautiful web apps. From sleek UIs to robust backend solutions, I build with precision and heart. 🌟 Let’s create something awesome together — explore my work and get in touch!" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://lucasbbs.live/images/preview.png" />
        <meta property="og:url" content="https://lucasbbs.live" />
        <title>
          {t('home.title') + ' | ' + t('home.name')}
        </title>
      </Helmet>
      <div style={{ ...styles.mainContainer }}>
        <div style={{ position: 'absolute', zIndex: 3 }}>
          <h1 style={{ ...styles.nameStyle }}>
            <ScrambleText text={t('home.name')} />
          </h1>
          <div style={{ flexDirection: 'row' }}>
            <h2 style={styles.inlineChild}>
              {t('home.heading')}
              &nbsp;
            </h2>
            <Typewriter
              wrapperClassName="h2"
              options={{
                loop: true,
                autoStart: true,
                strings: data?.roles[i18n.language],
              }}
            />
          </div>
          <Social />
        </div>
        <div style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
        }}
        >
          <ParticlesComponent />
        </div>
      </div>
    </Fade>
  ) : <FallbackSpinner />;
}

export default Home;
